import { GetStaticProps } from 'next';

import client from '@utils/apolloClient';
import { getFeatureEntryPoints } from '@queries/features.graphql';

import getEntryBoxInfo from '@utils/getEntryBoxInfo';
import getPagination from '@utils/getPagination';

import FeaturesPage from './archive/[page]';

export default FeaturesPage;

export const getStaticProps: GetStaticProps = async ({ ...ctx }) => {
  const siteConfig = await import(`~/siteconfig.json`);
  const currentPage: number = Number(ctx.params?.page || 1);

  const pageDescription = `Learn more about LEGO! Find out what are the biggest and best LEGO sets; what were the first sets and what are the rarest?`;

  const {
    data: { FeatureItems: features },
  } = await client.query({
    query: getFeatureEntryPoints,
    variables: {
      page: currentPage,
      length: siteConfig.pageSize,
    },
  });

  let pages = getPagination(
    'features',
    features.total,
    siteConfig.pageSize,
    currentPage
  );

  return {
    props: {
      currentPage,
      featureFlags: siteConfig.featureFlags,
      description: pageDescription,
      pages,
      posts: features.items.map((item) => getEntryBoxInfo(item, 'Features')),
      siteTitle: siteConfig.default.title,
    },
  };
};
